var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('navigation'),_c('router-view'),_c('footerDIV')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }